import {applyMiddleware, createStore, compose} from 'redux';
import {thunk} from "redux-thunk";
import allReducers from './reducers';
import {loadState} from './localStorage';

const configureStore = () => {
    const persistedState = loadState();

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    // TODO - we should move from redux to @reduxjs/toolkit
    const store = createStore(
        allReducers,
        persistedState,
        composeEnhancers(applyMiddleware(thunk)),
    );

    return store;
};


export default configureStore;
